import React, { useReducer, useState } from "react";
import { Board } from "./Board";
import { GameStatus } from "./GameStatus";
import { Stats } from "./Stats";
import { Stepper } from "./Stepper";
import { gameReducer, createInitialState } from "./gameReducer";
import { useRecordGame } from "./useRecordGame";
export const Main = () => {
    const [boardSize, setBoardSize] = useState(3);
    const [winLength, setWinLength] = useState(3);
    const [state, dispatch] = useReducer(gameReducer, undefined, createInitialState);
    const { stats } = useRecordGame(state);
    const startNewGame = (size, wl) => {
        dispatch({ type: "NEW_GAME", size, winLength: wl });
    };
    const handleBoardSizeChange = (newSize) => {
        const delta = newSize - boardSize;
        const newWinLength = Math.max(3, Math.min(newSize, winLength + delta));
        setBoardSize(newSize);
        setWinLength(newWinLength);
        startNewGame(newSize, newWinLength);
    };
    const handleWinLengthChange = (newWinLength) => {
        setWinLength(newWinLength);
        startNewGame(boardSize, newWinLength);
    };
    return (React.createElement("div", { className: "flex flex-col mt-10 items-center gap-10 px-4" },
        React.createElement("div", { className: "font-bold text-2xl" }, "Tic Tac Toe"),
        React.createElement("div", { className: "flex items-center gap-6" },
            React.createElement(Stepper, { label: "Board Size", value: boardSize, min: 3, max: 15, onChange: handleBoardSizeChange }),
            React.createElement(Stepper, { label: "To Win", value: winLength, min: 3, max: boardSize, onChange: handleWinLengthChange })),
        React.createElement(Board, { board: state.board, onCellSelect: (cell) => dispatch({ type: "MAKE_MOVE", cell }) }),
        React.createElement(GameStatus, { state: state }),
        React.createElement("button", { className: "px-4 py-2 bg-gray-900 text-white rounded hover:bg-gray-700", onClick: () => startNewGame(boardSize, winLength) }, state.status === "play" ? "Restart Game" : "New Game"),
        React.createElement(Stats, { stats: stats })));
};
